// extracted by mini-css-extract-plugin
module.exports = {"overlay":"MainPageOverlay0c27a82df6a60a46b1d3e6929d577c09"};